import { RainAttachFileCard } from '../cards/RainAttachFileCard';
import type { IChatMessage } from '@kognitos/lattice';

import type {
  IRainToolCallState,
  IRainToolRenderContext,
} from '../../hooks/types';

/**
 * `attach_file` opens a file picker to register Knowledge Files. While running
 * it renders the trigger into the picker; on confirm the chosen assets are
 * registered and the call resolved with their names; on cancel it fails
 * gracefully. Success and error render a read-only marker.
 */
export function renderAttachFileCard(
  state: IRainToolCallState,
  ctx: IRainToolRenderContext,
): IChatMessage {
  const reason =
    typeof state.args.reason === 'string' ? state.args.reason : undefined;
  // On success the tool result carries the attached file names (comma
  // separated) — surfaced on the resolved marker.
  const attachedNames =
    typeof state.result === 'string' && state.result.length > 0
      ? state.result
          .split(',')
          .map(name => name.trim())
          .filter(Boolean)
      : undefined;
  // Anything that isn't an in-flight ('running') or resolved ('success') call
  // renders as an error card.
  const cardStatus: 'running' | 'success' | 'error' =
    state.status === 'success' || state.status === 'running'
      ? state.status
      : 'error';
  return ctx.renderCustomCard(
    state,
    <RainAttachFileCard
      status={cardStatus}
      reason={reason}
      attachedNames={attachedNames}
      isSubmitting={state.isSubmitting}
      onConfirm={assets => ctx.resolvers.resolveAttachFile(state.id, assets)}
      onUploadFiles={files =>
        ctx.resolvers.resolveAttachFileUpload(state.id, files)
      }
      onCancel={() => ctx.resolvers.failAttachFile(state.id)}
    />,
  );
}
